import { PaintCollectionDisplay } from "@omni/types/components/paintConfigurator/enums/paintCollectionDisplay.enum";
import { Button } from "@omni/ui/components/Button/button.component";
import { useMapped } from "@omni/utils/context/mapped.context";
import { cn } from "@omni/utils/styles";

import { Family } from "@/components/PaintConfigurator/components/colors/components/families/components/colorList/components/family/family";
import { useColorsContext } from "@/components/PaintConfigurator/components/colors/context/colors.context";
import {
    useCollection,
    usePaintConfiguratorContext
} from "@/components/PaintConfigurator/context/paintConfigurator.context";

import { useColorListContext } from "../../context/colorsList.context";

const Color = () => {
    const { setSelectedColor } = useColorsContext();
    const { colors } = useColorListContext();
    const { nextStep } = usePaintConfiguratorContext();
    const { collection } = useCollection();
    const { index } = useMapped();
    const color = colors.at(index);

    const display = collection?.display ?? PaintCollectionDisplay.List;

    if (!color) return null;

    return (
        <>
            <div className={cn("tw:relative")}>
                {display === "list" && (
                    <Family className={cn("tw:absolute tw:left-0 tw:-top-8")} />
                )}
                <Button
                    className={cn(
                        "tw:p-0 tw:w-full tw:h-full tw:relative tw:border tw:overflow-hidden tw:text-left tw:border-gray-300 tw:hover:shadow-lg tw:transition-shadow"
                    )}
                    color="transparent"
                    onClick={() => {
                        setSelectedColor(color);
                        nextStep();
                    }}
                >
                    <div
                        className={cn(
                            "tw:aspect-4/3 tw:w-full tw:transition-transform tw:duration-300 tw:group-hover:scale-105"
                        )}
                        style={{
                            backgroundColor: `#${color.hexCode.replaceAll("#", "")}`
                        }}
                    ></div>
                    <div
                        className={cn(
                            "tw:p-3 tw:text-center tw:bg-background tw:text-grey-dark"
                        )}
                    >
                        <p
                            className={cn("tw:m-0!")}
                            title={color.name}
                        >
                            {color.name}
                        </p>
                    </div>
                </Button>
            </div>
            {display === "list" && index === colors.length - 1 && (
                <div className={cn("tw:col-span-full tw:h-16")} />
            )}
        </>
    );
};

export { Color };
